import { render, staticRenderFns } from "./CustomVenuesTab.vue?vue&type=template&id=0fa5cd8e&scoped=true&"
import script from "./CustomVenuesTab.vue?vue&type=script&lang=js&"
export * from "./CustomVenuesTab.vue?vue&type=script&lang=js&"
import style0 from "./CustomVenuesTab.vue?vue&type=style&index=0&id=0fa5cd8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa5cd8e",
  null
  
)

export default component.exports